<div class="file-upload-wrapper" [class.success]="uploadSuccess()" [class.error]="uploadError()"
  (drop)="onFileDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">
  <input type="file" accept="image/*" (change)="onFileChange($event)" hidden #fileInput />
  <div class="file-dropper">
    @if (imageName()) {
    <div>
      @if (imagePreview()) {
      <div>
        <img [src]="imagePreview()" alt="Image Preview" class="image-preview" />
      </div>
      }
    </div>
    }@else {
    <mat-icon class="rounded-icon">attach_file</mat-icon>
    <p i18n style="text-align: center;">Drag and Drop your image here or click here to select image file.</p>
    }
  </div>
</div>
@if (imagePreview()) {
<div>
  <div class="buttons-container">
    <button (click)="removeImage($event)" i18n>
      <mat-icon class="button-icon">delete</mat-icon>
      Remove
    </button>
    <button (click)="saveImageToS3($event)" [disabled]="!selectedFile()" i18n>
      <mat-icon class="button-icon button-icon-green">cloud_upload</mat-icon>
      Upload
    </button>
  </div>
</div>
}
<div class="error-container">
  @if (errors().fileSizeError) {
  <p i18n>File size must not exceed 3 MB.</p>
  }
  @if (errors().noImageError) {
  <p i18n>Only image files are supported.</p>
  }
  @if (errors().unsupportedFormatError) {
  <p i18n>Only JPEG and PNG formats are supported.</p>
  }
</div>